import {
  DataTableHeaderCell,
  type HeaderResizeProps,
} from "./DataTableHeaderCell";
import { cn } from "@/lib/utils";

type DataTableStaticHeaderProps = {
  label: string;
  className?: string;
} & HeaderResizeProps;

export function DataTableStaticHeader({
  label,
  className,
  ...resize
}: DataTableStaticHeaderProps) {
  return (
    <DataTableHeaderCell
      className={cn(
        className,
        "truncate text-xs font-medium text-surface-500",
      )}
      title={label}
      {...resize}
    >
      {label}
    </DataTableHeaderCell>
  );
}
